import { Button } from "@design-system/Button/Button";
import { FLAT_RATE_PLANS, flatRatePlanNames } from "@common/flatRateBilling";
import { usePlanManagement } from "@components/billing/PlanManagement/PlanManagementContext";
import { useMemo } from "react";
import { OverPageBillingCTA } from "@components/billing/PlanManagement/OverPageBillingCTA";
import { HStack } from "@design-system/HStack/HStack";
import { useSettings } from "../SettingsProvider";

interface Props {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    plan?: FLAT_RATE_PLANS;
    cta?: React.ReactNode;
    dismissKey?: string;
}

export const UpgradeCta = ({
    title,
    subtitle,
    plan,
    cta,
    dismissKey,
}: Props) => {
    const { upgrade } = usePlanManagement();
    const { open: openSettings } = useSettings();

    const ctaContent = useMemo(() => {
        if (cta) {
            return cta;
        }

        if (plan) {
            return (
                <HStack gap={12}>
                    <Button
                        variant="primary"
                        size="md"
                        onClick={() => openSettings(["plans"])}
                    >
                        View plans
                    </Button>
                    <Button
                        variant="tertiary"
                        size="md"
                        onClick={() => upgrade(plan, false)}
                    >
                        Upgrade to {flatRatePlanNames[plan]}
                    </Button>
                </HStack>
            );
        }

        return null;
    }, [cta, plan, upgrade, openSettings]);

    return (
        <OverPageBillingCTA
            title={title}
            subtitle={subtitle}
            cta={ctaContent}
            dismissKey={dismissKey}
        />
    );
};
